module.exports = __webpack_public_path__ + "bc61c84f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_login/ThirdLogin/weixin.png
// module id = 1188
// module chunks = 7